export var EField;
(function (EField) {
    EField["Members"] = "members";
    EField["Name"] = "name";
    EField["Property"] = "property";
})(EField || (EField = {}));
